import { md } from '@/utils/utils_html';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { DTOWorkspaceUserInvitation } from '@shared/dto/+workspace/workspace_user_invitation/dto_workspace_user_invitation';
import { format_timestamp_YY_MM_DD_HH_mm_ss } from '@shared/utils/utils_time';
import { WButtonUserInvitationCopyLink } from './buttons/WButtonUserInvitationCopyLink';
import { WButtonUserInvitationDelete } from './buttons/WButtonUserInvitationDelete';

interface Props {
  item: DTOWorkspaceUserInvitation;
}

export function WTableUserInvitationsRow({ item }: Props) {
  function get_status() {
    let out = '';
    if (item.accepted_at != CONSTANTS__shared.NUMBER_EMPTY_VALUE) {
      out = 'Accepted';
    } else if (item.rejected_at != CONSTANTS__shared.NUMBER_EMPTY_VALUE) {
      out = 'Rejected';
    } else {
      out = 'Pending';
    }

    return out;
  }

  return (
    <div className={`${md('px-2 justify-between', 'gap-5 px-5 justify-start')} w-full min-h-[50px] flex flex-row items-center `}>
      <span className={`${md('w-[45px] text-[9px]', 'w-[100px]')}  text-left`}>{get_status()}</span>
      <span className={`${md('w-[45px] text-[9px]', 'w-[280px]')}  text-left`}>{item.target_user_email}</span>
      <span className={`${md('w-[45px] text-[9px]', 'w-[160px]')}  text-left`}>{format_timestamp_YY_MM_DD_HH_mm_ss(item.created_at)}</span>
      <span className={`${md('w-[45px] text-[9px]', 'w-[120px]')}  text-center flex items-center justify-center`}>
        <WButtonUserInvitationCopyLink item={item} />
        <WButtonUserInvitationDelete item={item} />
      </span>
    </div>
  );
}
